import React from 'react'
import PropTypes from 'prop-types'
import Text from './Text'

class NavigationButton extends React.Component {
  render() {
    const {text, navigationFunction, SvgIcon} = this.props

    return (
      <div className="navigationButton">
        <button type="button" onClick={() => navigationFunction()}>
          {SvgIcon}
          <Text modifier="extrasmall" text={text} />
        </button>
      </div>
    )
  }
}

NavigationButton.propTypes = {
  navigationFunction: PropTypes.func,
  text: PropTypes.string,
  SvgIcon: PropTypes.object,
}

export default NavigationButton
